export const favorites = {
  title: "Moje ulubione",
  subtitle: "{{count}} zapisanych domów",
  countries: "Kraje",
  cities: "Miasta",
  emptyTitle: "Brak ulubionych na razie",
  emptyFiltered: "Spróbuj zmienić filtry, aby zobaczyć swoje ulubione.",
  emptyState:
    "Odkrywaj nasze wyjątkowe domy i dodawaj je do ulubionych, aby znaleźć je tutaj.",
  noFavoritesYet: "Brak ulubionych na razie",
  exploreMembersMap: "Przeglądaj mapę członków, aby znaleźć domy",
  exploreMap: "Przeglądaj mapę",
  backToHome: "Powrót do strony głównej",
  howToAddFavorites: "Jak dodać do ulubionych?",
  step1: "Przejdź na",
  step2: "mapę członków",
  step3: "i kliknij serce",
  step3End: "aby dodać dom do ulubionych",
  membersMapLink: "Mapa członków",
  properties: "nieruchomości",
  selected: "wybrane",
  compare: "Porównaj",
  actions: "Akcje",
  contact: "Kontakt",
  exchange: "Zaproponuj wymianę",
  removeFromFavorites: "Usuń z ulubionych",
  removeFromComparison: "Usuń z porównania",
  owner: "Właściciel",
  ratingLabel: "Ocena",
  exchangesLabel: "Wymiany",
  exchangesCount: "wymian",
  exchangesCompleted: "zrealizowane wymiany",
  capacityLabel: "Pojemność",
  guestsCount: "podróżnych",
  numberOfRooms: "pokoje",
  roomsCount: "pokoje",
  onlineStatus: "Połączony",
  onlineBadge: "Połączony",
  verifiedStatus: "Zweryfikowany",
  verifiedBadge: "Zweryfikowany",
  no: "Nie",
};
